import { render, staticRenderFns } from "./le-upload-file-img-ly.vue?vue&type=template&id=8b001ece&scoped=true&"
import script from "./le-upload-file-img-ly.vue?vue&type=script&lang=js&"
export * from "./le-upload-file-img-ly.vue?vue&type=script&lang=js&"
import style0 from "./le-upload-file-img-ly.vue?vue&type=style&index=0&id=8b001ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b001ece",
  null
  
)

export default component.exports